<template>
  <ListingsFilterControl label="Hide contacts with CRM activity since">
    <DatePicker v-model="model" placeholder="Select date" :disabled-dates="disabledDates" />
  </ListingsFilterControl>
</template>

<script lang="ts" setup>
  // Components
  import ListingsFilterControl from '~/misc/listings/filters/control/ListingsFilterControl.vue';
  import DatePicker from '~/misc/date-picker/DatePicker.vue';

  const model = defineModel({
    type: [String, null] as PropType<string | null>,
    required: true,
  });

  const disabledDates = (dateToCheck: Date) => {
    const today: Date = new Date();
    today.setHours(0, 0, 0, 0);

    return dateToCheck > today;
  };
</script>
